import React, { Suspense, lazy, useEffect } from 'react';
import Subhero from "../subhero/Subhero";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'

const ContactForm = lazy(() => import("../contact-form/ContactForm"))

const PageMailwallStartfreetrial = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Advanced Email Security Made Simple</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>
            <main className={"Page"}>
                <Subhero>
                <div className="main-title">Experience Our Technology In Action See immediate Results Very Quick & Easy Set-Up</div>
                    <ul className="main-list">
                        <li> Instant Activation</li>
                        <li> No Credit Card Required</li>
                    </ul>
                </Subhero>
            </main>
            <Suspense fallback={<Placeholder />}>
                <ContactForm variant={"mailwall"} />
            </Suspense>
        </>
    )
}

export default PageMailwallStartfreetrial;